import { Sheet, SheetContent } from "../ui/sheet";
import Sidebar from "./Sidebar";

export default function MobileDrawer({ open, onOpenChange }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="left"
        className="p-0 w-[280px] border-0"
        data-testid="mobile-drawer"
      >
        <div className="h-full">
          <Sidebar collapsed={false} onToggle={() => onOpenChange(false)} />
        </div>
      </SheetContent>
    </Sheet>
  );
}
